(() => {
  const ICONS = {
    woman: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="3.5"/><path d="M5.5 20c.6-5 2.7-7.5 6.5-7.5s5.9 2.5 6.5 7.5"/></svg>',
    man: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="7" r="3.5"/><path d="M5.5 20c.6-5 2.7-7.5 6.5-7.5s5.9 2.5 6.5 7.5M15.5 3.5 20 4l-.5 4.5"/></svg>',
    unisex: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="8" r="3"/><circle cx="16" cy="9" r="2.5"/><path d="M3.5 20c.5-4.2 2.3-6.5 5.5-6.5s5 2.3 5.5 6.5M13.5 14.5c.8-.7 1.6-1 2.6-1 2.5 0 4 2.1 4.4 5.7"/></svg>',
    any: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16M12 4v16M6.3 6.3l11.4 11.4M17.7 6.3 6.3 17.7"/><circle cx="12" cy="12" r="9"/></svg>',
    fresh: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3c3.8 4.3 6 7.2 6 10.3A6 6 0 0 1 6 13.3C6 10.2 8.2 7.3 12 3Z"/><path d="M9 15.5c.8 1 1.8 1.5 3 1.5"/></svg>',
    sweet: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 9 3 3-3 3-3-3 3-3ZM19 9l3 3-3 3-3-3 3-3ZM8 12h8M9 6h6l2 6-2 6H9l-2-6 2-6Z"/></svg>',
    fruity: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7c-5-2-8 1-7 6 1.2 6.1 5.1 8.2 7 5.5 1.9 2.7 5.8.6 7-5.5 1-5-2-8-7-6Z"/><path d="M12 7c0-3 1.5-5 4-5M13 5c2.6-1 4.7-.4 6 1.5"/></svg>',
    floral: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="2.5"/><path d="M12 9.5C8 8 8 4 10 3c2-1 4 2 2 6.5ZM14.5 12c1.5-4 5.5-4 6.5-2 1 2-2 4-6.5 2ZM12 14.5c4 1.5 4 5.5 2 6.5-2 1-4-2-2-6.5ZM9.5 12C8 16 4 16 3 14c-1-2 2-4 6.5-2Z"/></svg>',
    elegant: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 3 2.2 4.8L19 10l-4.8 2.2L12 17l-2.2-4.8L5 10l4.8-2.2L12 3Z"/><path d="m19 16 .8 1.7L21.5 19l-1.7.8L19 21.5l-.8-1.7-1.7-.8 1.7-.8L19 16Z"/></svg>',
    dark: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19.8 15.5A8.5 8.5 0 0 1 8.5 4.2 8.5 8.5 0 1 0 19.8 15.5Z"/><path d="m17 4 .5 1.5L19 6l-1.5.5L17 8l-.5-1.5L15 6l1.5-.5L17 4Z"/></svg>',
    woody: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3 5 12h4l-4 6h14l-4-6h4l-7-9ZM12 18v3"/></svg>',
    subtle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h2M10 12h2M15 12h4"/><circle cx="6" cy="12" r="4"/></svg>',
    balanced: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h16M7 8v8M12 6v12M17 8v8"/></svg>',
    bold: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13 3 5 14h6l-1 7 9-12h-6V3Z"/></svg>',
    daily: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9 7 7M17 17l2.1 2.1M19.1 4.9 17 7M7 17l-2.1 2.1"/></svg>',
    office: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M8 7V4h8v3M3 12h18M10 12v2h4v-2"/></svg>',
    date: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 8.5c0 5-8 10.5-8 10.5S4 13.5 4 8.5A4.5 4.5 0 0 1 12 5.7a4.5 4.5 0 0 1 8 2.8Z"/></svg>',
    evening: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19.8 15.5A8.5 8.5 0 0 1 8.5 4.2 8.5 8.5 0 1 0 19.8 15.5Z"/><path d="M17 4h3M18.5 2.5v3"/></svg>',
    universal: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.5 2.5 3.8 5.5 3.8 9S14.5 18.5 12 21c-2.5-2.5-3.8-5.5-3.8-9S9.5 5.5 12 3Z"/></svg>',
    avoid: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="m6 6 12 12"/></svg>',
    perfume: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 3h6v4H9zM8 7h8l2 4v9H6v-9l2-4Z"/><path d="M9 12h6v5H9z"/></svg>',
    unknown: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M9.5 9a2.7 2.7 0 1 1 3.3 2.6c-.8.3-.8.9-.8 1.7M12 17h.01"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 4 4L19 6"/></svg>',
    bottle: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 2h6v4H9zM7 6h10l2 4v11H5V10l2-4Z"/></svg>',
  };

  const MOOD_LABELS = {
    fresh: 'gaivią ir švarią',
    sweet: 'saldžią ir jaukią',
    fruity: 'vaisingą ir žaismingą',
    floral: 'gėlišką ir romantišką',
    elegant: 'elegantišką ir prabangią',
    dark: 'tamsią ir viliojančią',
    woody: 'medienos ir prieskonių',
  };

  const CHIP_LABELS = {
    fresh: 'Gaivus',
    sweet: 'Saldus',
    fruity: 'Vaisingas',
    floral: 'Gėliškas',
    elegant: 'Elegantiškas',
    dark: 'Tamsus',
    woody: 'Medienos',
  };

  const INTENSITY_LABELS = {
    1: 'subtilaus',
    2: 'subalansuoto',
    3: 'ryškaus',
  };

  const INTENSITY_DISPLAY = {
    1: 'Subtilus',
    2: 'Subalansuotas',
    3: 'Ryškus',
  };

  const OCCASION_LABELS = {
    daily: 'kasdienai',
    office: 'darbui',
    date: 'pasimatymui',
    evening: 'vakarui ar šventei',
    universal: 'įvairioms progoms',
  };

  const FAVORITE_LABELS = {
    br540: 'Baccarat Rouge 540',
    lost_cherry: 'Lost Cherry',
    libre: 'Libre',
    good_girl: 'Good Girl',
    bright_crystal: 'Bright Crystal',
    sauvage: 'Sauvage',
    aventus: 'Aventus',
    swy: 'Stronger With You',
    acqua: 'Acqua di Gio',
    one_million: '1 Million',
  };

  const FAVORITE_PROFILES = {
    br540: { families: ['sweet', 'elegant', 'dark'], intensity: 3 },
    lost_cherry: { families: ['sweet', 'fruity', 'dark'], intensity: 3 },
    libre: { families: ['elegant', 'floral', 'sweet'], intensity: 2 },
    good_girl: { families: ['sweet', 'elegant', 'dark'], intensity: 3 },
    bright_crystal: { families: ['fresh', 'fruity', 'floral'], intensity: 1 },
    sauvage: { families: ['fresh', 'woody', 'elegant'], intensity: 3 },
    aventus: { families: ['fresh', 'fruity', 'woody'], intensity: 2 },
    swy: { families: ['sweet', 'woody', 'dark'], intensity: 3 },
    acqua: { families: ['fresh', 'elegant'], intensity: 2 },
    one_million: { families: ['sweet', 'elegant', 'dark'], intensity: 3 },
  };

  class SatejaFragranceQuiz extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.config = this.parseJSON('[data-sfq-config]', {});
      this.products = this.parseJSON('[data-sfq-products]', []).filter(
        (product) => product && product.available && Array.isArray(product.variants) && product.variants.length
      );
      this.currentStep = 0;
      this.answers = {};
      this.pendingAdvance = null;

      this.intro = this.querySelector('[data-sfq-intro]');
      this.quiz = this.querySelector('[data-sfq-quiz]');
      this.results = this.querySelector('[data-sfq-results]');
      this.questionWrap = this.querySelector('[data-sfq-question-wrap]');
      this.message = this.querySelector('[data-sfq-message]');
      this.nextButton = this.querySelector('[data-sfq-next]');
      this.backButton = this.querySelector('[data-sfq-back]');
      this.progress = this.querySelector('[data-sfq-progress]');
      this.progressFill = this.querySelector('[data-sfq-progress-fill]');
      this.stepLabel = this.querySelector('[data-sfq-step-label]');
      this.resultGrid = this.querySelector('[data-sfq-result-grid]');
      this.resultsTitle = this.querySelector('[data-sfq-results-title]');
      this.resultsSummary = this.querySelector('[data-sfq-results-summary]');

      this.steps = this.buildSteps();
      this.bindEvents();
    }

    parseJSON(selector, fallback) {
      const script = this.querySelector(selector);
      if (!script) return fallback;
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Nepavyko nuskaityti kvapo testo duomenų.', error);
        return fallback;
      }
    }

    buildSteps() {
      const questions = this.config.questions || {};
      return [
        {
          key: 'audience',
          title: questions.audience || 'Kam ieškai kvapo?',
          type: 'single',
          options: [
            { value: 'women', title: 'Moteriai', description: 'Moteriški ir tinkami unisex kvapai', icon: 'woman' },
            { value: 'men', title: 'Vyrui', description: 'Vyriški ir tinkami unisex kvapai', icon: 'man' },
            { value: 'unisex', title: 'Unisex', description: 'Kvapai be griežtų ribų', icon: 'unisex' },
            { value: 'any', title: 'Nesvarbu', description: 'Svarbiausia pats aromatas', icon: 'any' },
          ],
        },
        {
          key: 'mood',
          title: questions.mood || 'Kokią nuotaiką turėtų kurti tavo kvapas?',
          help: 'Gali pasirinkti iki 2 variantų.',
          type: 'multi',
          max: 2,
          optionsClass: 'mood',
          options: [
            { value: 'fresh', title: 'Gaivus ir švarus', description: 'Lengvas, švarus, gaivinantis', icon: 'fresh' },
            { value: 'sweet', title: 'Saldus ir jaukus', description: 'Šiltas, gardus, apgaubiantis', icon: 'sweet' },
            { value: 'fruity', title: 'Vaisingas ir žaismingas', description: 'Sultingas, energingas, ryškus', icon: 'fruity' },
            { value: 'floral', title: 'Gėliškas ir romantiškas', description: 'Švelnus, moteriškas, elegantiškas', icon: 'floral' },
            { value: 'elegant', title: 'Elegantiškas ir prabangus', description: 'Tvarkingas, išbaigtas, solidus', icon: 'elegant' },
            { value: 'dark', title: 'Tamsus ir viliojantis', description: 'Gilus, paslaptingas, vakarinis', icon: 'dark' },
            { value: 'woody', title: 'Medienos ir prieskonių', description: 'Sausas, šiltas, charakteringas', icon: 'woody' },
          ],
        },
        {
          key: 'intensity',
          title: questions.intensity || 'Kokio intensyvumo kvapo nori?',
          type: 'single',
          options: [
            { value: '1', title: 'Subtilaus', description: 'Jaučiamo daugiausia iš arti', icon: 'subtle' },
            { value: '2', title: 'Subalansuoto', description: 'Pastebimo, bet ne per stipraus', icon: 'balanced' },
            { value: '3', title: 'Ryškaus', description: 'Paliekančio aiškų kvapo šleifą', icon: 'bold' },
          ],
        },
        {
          key: 'occasion',
          title: questions.occasion || 'Kada dažniausiai jį naudosi?',
          type: 'single',
          options: [
            { value: 'daily', title: 'Kasdien', description: 'Patogus dažnam naudojimui', icon: 'daily' },
            { value: 'office', title: 'Darbe', description: 'Tvarkingas ir neįkyrus', icon: 'office' },
            { value: 'date', title: 'Pasimatymui', description: 'Patrauklus ir įsimenantis', icon: 'date' },
            { value: 'evening', title: 'Vakarui ar šventei', description: 'Ryškesnis ir išskirtinis', icon: 'evening' },
            { value: 'universal', title: 'Noriu universalaus', description: 'Tinkančio įvairioms progoms', icon: 'universal' },
          ],
        },
        {
          key: 'avoid',
          title: questions.avoid || 'Ko savo kvape nenorėtum?',
          help: 'Gali pasirinkti kelis variantus.',
          type: 'multi',
          options: [
            { value: 'sweet', title: 'Labai saldžių aromatų', description: 'Vengti ryškiai saldžių kvapų', icon: 'avoid', avoidFamily: 'sweet' },
            { value: 'floral', title: 'Gėlių', description: 'Vengti ryškių gėlių natų', icon: 'floral', avoidNote: 'floral' },
            { value: 'vanilla', title: 'Vanilės', description: 'Vengti šiltos vanilės', icon: 'sweet', avoidNote: 'vanilla' },
            { value: 'citrus', title: 'Citrusų', description: 'Vengti gaivių citrusinių natų', icon: 'fresh', avoidNote: 'citrus' },
            { value: 'tobacco_spicy', title: 'Tabako ir prieskonių', description: 'Vengti dūminių ir aštresnių natų', icon: 'dark', avoidNotes: ['tobacco', 'spicy'] },
            { value: 'woody', title: 'Medienos arba oud', description: 'Vengti sausų medienos natų', icon: 'woody', avoidNote: 'woody' },
            { value: 'none', title: 'Neturiu nemėgstamų', description: 'Esu atviras įvairiems aromatams', icon: 'any', exclusive: true },
          ],
        },
        {
          key: 'favorite',
          title: questions.favorite || 'Kokie kvepalai tau jau patinka?',
          help: 'Tai padės tiksliau suprasti tavo mėgstamą kryptį.',
          type: 'single',
          optionsClass: 'favorite',
          options: [
            { value: 'br540', title: 'Baccarat Rouge 540', icon: 'perfume' },
            { value: 'lost_cherry', title: 'Lost Cherry', icon: 'perfume' },
            { value: 'libre', title: 'Libre', icon: 'perfume' },
            { value: 'good_girl', title: 'Good Girl', icon: 'perfume' },
            { value: 'bright_crystal', title: 'Bright Crystal', icon: 'perfume' },
            { value: 'sauvage', title: 'Sauvage', icon: 'perfume' },
            { value: 'aventus', title: 'Aventus', icon: 'perfume' },
            { value: 'swy', title: 'Stronger With You', icon: 'perfume' },
            { value: 'acqua', title: 'Acqua di Gio', icon: 'perfume' },
            { value: 'one_million', title: '1 Million', icon: 'perfume' },
            { value: 'none', title: 'Nežinau / neturiu mėgstamiausių', icon: 'unknown' },
          ],
        },
      ];
    }

    bindEvents() {
      this.querySelector('[data-sfq-start]')?.addEventListener('click', () => this.start());
      this.querySelector('[data-sfq-close]')?.addEventListener('click', () => this.showIntro());
      this.querySelector('[data-sfq-restart]')?.addEventListener('click', () => this.restart());
      this.backButton?.addEventListener('click', () => this.goBack());
      this.nextButton?.addEventListener('click', () => this.goNext());
      this.questionWrap?.addEventListener('click', (event) => {
        const option = event.target.closest('[data-sfq-option]');
        if (option) this.selectOption(option.dataset.value);
      });
      this.resultGrid?.addEventListener('change', (event) => {
        const select = event.target.closest('[data-sfq-variant]');
        if (select) this.updateVariant(select);
      });
      this.resultGrid?.addEventListener('submit', (event) => {
        const form = event.target.closest('[data-sfq-product-form]');
        if (form) this.addToCart(event, form);
      });
      this.resultGrid?.addEventListener('click', (event) => {
        const link = event.target.closest('[data-sfq-product-link]');
        if (link) this.track('fragrance_quiz_product_click', { product_handle: link.dataset.productHandle || '' });
      });
    }

    start() {
      if (this.products.length < 3) return;
      this.currentStep = 0;
      this.answers = {};
      this.intro.hidden = true;
      this.results.hidden = true;
      this.quiz.hidden = false;
      this.renderQuestion();
      this.track('fragrance_quiz_start', { product_pool: this.products.length });
      this.keepSectionVisible();
    }

    restart() {
      this.start();
    }

    showIntro() {
      window.clearTimeout(this.pendingAdvance);
      this.quiz.hidden = true;
      this.results.hidden = true;
      this.intro.hidden = false;
      this.currentStep = 0;
      this.answers = {};
      this.keepSectionVisible();
    }

    goBack() {
      window.clearTimeout(this.pendingAdvance);
      if (this.currentStep === 0) {
        this.showIntro();
        return;
      }
      this.currentStep -= 1;
      this.renderQuestion();
    }

    goNext() {
      const step = this.steps[this.currentStep];
      const answer = this.answers[step.key];
      const hasAnswer = Array.isArray(answer) ? answer.length > 0 : Boolean(answer);
      if (!hasAnswer) {
        this.showMessage('Pasirink bent vieną variantą.');
        return;
      }
      this.advance();
    }

    advance() {
      if (this.currentStep >= this.steps.length - 1) {
        this.showResults();
        return;
      }
      this.currentStep += 1;
      this.renderQuestion();
    }

    renderQuestion() {
      const step = this.steps[this.currentStep];
      const currentAnswer = this.answers[step.key];
      this.stepLabel.textContent = `${this.currentStep + 1} iš ${this.steps.length}`;
      this.progress.setAttribute('aria-valuenow', String(this.currentStep + 1));
      this.progressFill.style.width = `${((this.currentStep + 1) / this.steps.length) * 100}%`;
      this.backButton.hidden = false;
      this.nextButton.hidden = step.type !== 'multi';
      this.showMessage('');

      const options = step.options
        .map((option) => {
          const isSelected = Array.isArray(currentAnswer)
            ? currentAnswer.includes(option.value)
            : currentAnswer === option.value;
          return `
            <button
              type="button"
              class="sfq__option${isSelected ? ' is-selected' : ''}"
              data-sfq-option
              data-value="${this.escapeHTML(option.value)}"
              aria-pressed="${isSelected ? 'true' : 'false'}"
            >
              <span class="sfq__option-icon">${ICONS[option.icon] || ICONS.perfume}</span>
              <span class="sfq__option-text">
                <span class="sfq__option-title">${this.escapeHTML(option.title)}</span>
                ${option.description ? `<span class="sfq__option-description">${this.escapeHTML(option.description)}</span>` : ''}
              </span>
              <span class="sfq__option-check">${ICONS.check}</span>
            </button>
          `;
        })
        .join('');

      this.questionWrap.innerHTML = `
        <div class="sfq__question-content">
          <p class="sfq__question-kicker">KLAUSIMAS ${this.currentStep + 1}</p>
          <h3 class="sfq__question" tabindex="-1">${this.escapeHTML(step.title)}</h3>
          ${step.help ? `<p class="sfq__question-help">${this.escapeHTML(step.help)}</p>` : ''}
          <div class="sfq__options${step.optionsClass ? ` sfq__options--${step.optionsClass}` : ''}">
            ${options}
          </div>
        </div>
      `;

      requestAnimationFrame(() => this.questionWrap.querySelector('.sfq__question')?.focus({ preventScroll: true }));
      this.track('fragrance_quiz_step', { step: this.currentStep + 1, question: step.key });
      this.keepSectionVisible();
    }

    selectOption(value) {
      const step = this.steps[this.currentStep];
      const optionConfig = step.options.find((option) => option.value === value);
      if (!optionConfig) return;

      if (step.type === 'multi') {
        let selected = Array.isArray(this.answers[step.key]) ? [...this.answers[step.key]] : [];
        if (optionConfig.exclusive) {
          selected = selected.includes(value) ? [] : [value];
        } else {
          selected = selected.filter((item) => item !== 'none');
          if (selected.includes(value)) {
            selected = selected.filter((item) => item !== value);
          } else if (!step.max || selected.length < step.max) {
            selected.push(value);
          } else {
            this.showMessage(`Gali pasirinkti ne daugiau kaip ${step.max} variantus.`);
            return;
          }
        }
        this.answers[step.key] = selected;
        this.updateOptionStates(selected);
        this.showMessage('');
        return;
      }

      this.answers[step.key] = value;
      this.updateOptionStates(value);
      window.clearTimeout(this.pendingAdvance);
      this.pendingAdvance = window.setTimeout(() => this.advance(), 220);
    }

    updateOptionStates(answer) {
      this.questionWrap.querySelectorAll('[data-sfq-option]').forEach((button) => {
        const selected = Array.isArray(answer) ? answer.includes(button.dataset.value) : answer === button.dataset.value;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    showMessage(text) {
      if (this.message) this.message.textContent = text;
    }

    scoreProducts() {
      const audience = this.answers.audience;
      const moods = this.answers.mood || [];
      const intensity = Number(this.answers.intensity || 2);
      const occasion = this.answers.occasion;
      const avoid = this.answers.avoid || [];
      const favorite = this.answers.favorite;
      const favoriteProfile = FAVORITE_PROFILES[favorite];
      const avoidStep = this.steps.find((step) => step.key === 'avoid');

      return this.products
        .map((product, index) => {
          let score = 0;
          let conflict = false;

          if (audience === 'women') {
            if (product.audience === 'men') return null;
            score += product.audience === 'women' ? 7 : 4;
          } else if (audience === 'men') {
            if (product.audience === 'women') return null;
            score += product.audience === 'men' ? 7 : 4;
          } else if (audience === 'unisex') {
            if (product.audience !== 'unisex') return null;
            score += 7;
          } else {
            score += 2;
          }

          moods.forEach((mood) => {
            if (product.families?.[mood]) score += 5;
          });

          const intensityDistance = Math.abs(Number(product.intensity) - intensity);
          if (intensityDistance === 0) score += 5;
          else if (intensityDistance === 1) score += 1.5;
          else score -= 2;

          if (occasion && product.occasions?.[occasion]) score += 5;
          else if (product.occasions?.universal) score += 1.5;

          avoid.forEach((avoidValue) => {
            if (avoidValue === 'none') return;
            const config = avoidStep?.options.find((option) => option.value === avoidValue);
            if (!config) return;
            if (config.avoidFamily && product.families?.[config.avoidFamily]) conflict = true;
            if (config.avoidNote && product.notes?.[config.avoidNote]) conflict = true;
            if (config.avoidNotes?.some((note) => product.notes?.[note])) conflict = true;
          });

          if (favorite && favorite !== 'none') {
            if (product.favoriteKey === favorite) score += 10;
            if (favoriteProfile) {
              favoriteProfile.families.forEach((family) => {
                if (product.families?.[family]) score += 1.6;
              });
              if (Number(product.intensity) === favoriteProfile.intensity) score += 1.5;
            }
          }

          if (product.safe) score += 0.6;
          score -= index * 0.002;

          return { product, score, conflict };
        })
        .filter(Boolean)
        .sort((a, b) => {
          if (a.conflict !== b.conflict) return a.conflict ? 1 : -1;
          return b.score - a.score;
        });
    }

    chooseResults(ranked) {
      if (!ranked.length) return [];
      const compatible = ranked.filter((item) => !item.conflict);
      const pool = compatible.length >= 3 ? compatible : ranked;
      const selected = [];

      const take = (predicate) => {
        const item = pool.find((candidate) => !selected.includes(candidate) && predicate(candidate.product));
        if (item) selected.push(item);
        return item;
      };

      take(() => true);
      take((product) => product.safe);
      take((product) => !product.safe || Number(product.intensity) === 3 || product.families?.dark);

      while (selected.length < Math.min(3, pool.length)) take(() => true);
      return selected;
    }

    showResults() {
      window.clearTimeout(this.pendingAdvance);
      const ranked = this.scoreProducts();
      const selected = this.chooseResults(ranked);
      this.quiz.hidden = true;
      this.intro.hidden = true;
      this.results.hidden = false;
      this.resultsSummary.textContent = this.buildSummary();

      if (!selected.length) {
        this.resultGrid.innerHTML = '<p class="sfq__empty-results">Šiuo metu nepavyko parinkti galimų produktų. Pabandyk dar kartą.</p>';
      } else {
        const roles = [
          { label: 'Geriausias atitikimas', type: 'best' },
          { label: 'Saugus pasirinkimas', type: 'safe' },
          { label: 'Drąsesnis pasirinkimas', type: 'bold' },
        ];
        this.resultGrid.innerHTML = selected
          .map((item, index) => this.renderProductCard(item.product, roles[index] || roles[0], index))
          .join('');
      }

      requestAnimationFrame(() => this.resultsTitle?.focus({ preventScroll: true }));
      this.keepSectionVisible(true);
      this.track('fragrance_quiz_complete', {
        audience: this.answers.audience || '',
        mood: (this.answers.mood || []).join(','),
        intensity: this.answers.intensity || '',
        occasion: this.answers.occasion || '',
        recommendations: selected.map((item) => item.product.handle).join(','),
      });
    }

    buildSummary() {
      const moods = (this.answers.mood || []).map((mood) => MOOD_LABELS[mood]).filter(Boolean);
      const moodText = this.joinNaturally(moods);
      const intensity = INTENSITY_LABELS[Number(this.answers.intensity)] || 'subalansuoto';
      const occasion = OCCASION_LABELS[this.answers.occasion] || 'įvairioms progoms';
      return `Pagal tavo atsakymus ieškai ${moodText || 'tavo skoniui artimos'} krypties, ${intensity} kvapo, tinkamo ${occasion}.`;
    }

    buildReason(product, role) {
      const matchedMoods = (this.answers.mood || [])
        .filter((mood) => product.families?.[mood])
        .map((mood) => MOOD_LABELS[mood]);
      const parts = [];

      if (role.type === 'safe') {
        parts.push('Universalesnis pasirinkimas, jei kvapą perki jo prieš tai neišbandęs.');
      } else if (role.type === 'bold') {
        parts.push('Drąsesnė ir labiau išsiskirianti tavo kvapo profilio interpretacija.');
      }

      if (matchedMoods.length) {
        parts.push(`Atitinka tavo pasirinktą ${this.joinNaturally(matchedMoods)} kryptį.`);
      }

      if (this.answers.favorite && this.answers.favorite !== 'none' && product.favoriteKey === this.answers.favorite) {
        parts.push(`Artimas tavo mėgstamai „${FAVORITE_LABELS[this.answers.favorite]}“ aromato krypčiai.`);
      }

      if (product.occasions?.[this.answers.occasion]) {
        const occasionLabel = OCCASION_LABELS[this.answers.occasion];
        if (occasionLabel) parts.push(`Ypač tinkamas ${occasionLabel}.`);
      }

      if (!parts.length) parts.push('Subalansuotas pasirinkimas pagal tavo atsakymų visumą.');
      return parts.join(' ');
    }

    renderProductCard(product, role, index) {
      const firstVariant = product.variants[0];
      const chips = Object.keys(product.families || {})
        .filter((family) => product.families[family])
        .slice(0, 3)
        .map((family) => `<span class="sfq__profile-chip">${this.escapeHTML(CHIP_LABELS[family] || family)}</span>`)
        .join('');
      const intensityDots = [1, 2, 3]
        .map(
          (dot) =>
            `<span class="sfq__intensity-dot${dot <= Number(product.intensity) ? ' is-active' : ''}" aria-hidden="true"></span>`
        )
        .join('');
      const options = product.variants
        .map(
          (variant) =>
            `<option value="${this.escapeHTML(String(variant.id))}" data-price="${this.escapeHTML(variant.price)}">${this.escapeHTML(
              variant.title
            )}</option>`
        )
        .join('');
      const image = product.image
        ? `<img class="sfq__result-image" src="${this.escapeHTML(product.image)}" alt="${this.escapeHTML(
            product.shortTitle
          )}" width="760" height="760" loading="lazy">`
        : `<span class="sfq__result-image-placeholder">${ICONS.bottle}</span>`;

      return `
        <article class="sfq__result-card" data-result-index="${index}">
          <span class="sfq__result-label">${this.escapeHTML(role.label)}</span>
          <a class="sfq__result-image-link" href="${this.escapeHTML(product.url)}" data-sfq-product-link data-product-handle="${this.escapeHTML(
            product.handle
          )}">
            ${image}
          </a>
          <div class="sfq__result-content">
            <h3 class="sfq__result-title">
              <a href="${this.escapeHTML(product.url)}" data-sfq-product-link data-product-handle="${this.escapeHTML(product.handle)}">
                ${this.escapeHTML(product.shortTitle)}
              </a>
            </h3>
            <p class="sfq__result-reason">${this.escapeHTML(this.buildReason(product, role))}</p>
            <div class="sfq__profile-chips">${chips}</div>
            <div class="sfq__intensity">
              <span>Intensyvumas:</span>
              <span class="sfq__intensity-dots">${intensityDots}</span>
              <span>${this.escapeHTML(INTENSITY_DISPLAY[Number(product.intensity)] || '')}</span>
            </div>
            <form class="sfq__result-form" method="post" action="${this.cartAddUrl()}" data-sfq-product-form>
              <input type="hidden" name="id" value="${this.escapeHTML(String(firstVariant.id))}" data-sfq-variant-id>
              <input type="hidden" name="quantity" value="1">
              <div class="sfq__variant-row">
                <select class="sfq__variant-select" data-sfq-variant aria-label="Pasirinkti dydį">
                  ${options}
                </select>
                <span class="sfq__price" data-sfq-price>${this.escapeHTML(firstVariant.price)}</span>
              </div>
              <div class="sfq__product-error" role="alert" hidden data-sfq-error></div>
              <button class="sfq__cart-button" type="submit">
                <span data-sfq-button-text>${this.escapeHTML(this.config.addToCartLabel || 'Įdėti į krepšelį')}</span>
                <span class="loading__spinner hidden" aria-hidden="true">
                  <svg viewBox="0 0 66 66"><circle cx="33" cy="33" r="29" fill="none" stroke="currentColor" stroke-width="6" stroke-dasharray="136 45"/></svg>
                </span>
              </button>
            </form>
          </div>
        </article>
      `;
    }

    updateVariant(select) {
      const form = select.closest('[data-sfq-product-form]');
      if (!form) return;
      const option = select.selectedOptions[0];
      const idInput = form.querySelector('[data-sfq-variant-id]');
      const price = form.querySelector('[data-sfq-price]');
      if (idInput) idInput.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
    }

    async addToCart(event, form) {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const spinner = form.querySelector('.loading__spinner');
      const errorBox = form.querySelector('[data-sfq-error]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;

      button.setAttribute('aria-disabled', 'true');
      spinner?.classList.remove('hidden');
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(form);
      if (cart?.getSectionsToRender) {
        formData.append(
          'sections',
          cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }

      try {
        const response = await fetch(this.cartAddUrl(), {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData,
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'Nepavyko įdėti produkto.');

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'sateja-fragrance-quiz',
            productVariantId: formData.get('id'),
            cartData: data,
          });
        }

        if (cart?.renderContents) {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          await this.refreshCartBubble();
        }

        this.track('fragrance_quiz_add_to_cart', { variant_id: String(formData.get('id') || '') });
      } catch (error) {
        if (errorBox) {
          errorBox.textContent = error.message || 'Įvyko klaida. Pabandyk dar kartą.';
          errorBox.hidden = false;
        }
      } finally {
        button.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
      }
    }

    async refreshCartBubble() {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
        const cart = await response.json();
        const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (bubble) {
          const count = bubble.querySelector('span[aria-hidden="true"]');
          if (count) count.textContent = String(cart.item_count);
        }
      } catch (error) {
        console.warn('Nepavyko atnaujinti krepšelio skaičiaus.', error);
      }
    }

    cartAddUrl() {
      return window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;
    }

    track(eventName, parameters = {}) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...parameters });
      if (eventName === 'fragrance_quiz_complete' && typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'FragranceQuizComplete', parameters);
      }
    }

    keepSectionVisible(force = false) {
      requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect();
        const shouldScroll = force || rect.top < -20 || rect.top > window.innerHeight * 0.48;
        if (shouldScroll) {
          this.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
      });
    }

    joinNaturally(items) {
      if (!items.length) return '';
      if (items.length === 1) return items[0];
      return `${items.slice(0, -1).join(', ')} ir ${items[items.length - 1]}`;
    }

    escapeHTML(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }

  if (!customElements.get('sateja-fragrance-quiz')) {
    customElements.define('sateja-fragrance-quiz', SatejaFragranceQuiz);
  }
})();
